import { yupResolver } from "@hookform/resolvers/yup";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { setData } from "../../../Landing/input.slice.js";
import { useInputFormsHook } from "../../hooks";
import { personalFormSchema } from "./validation.js";
import { toast } from "react-toastify";
import { useHeaderData } from "../../../../components/Header/hooks/useHeaderData.js";

const usePersonalForm = (current, setCurrent) => {
  const { getPersonalFormData, setPersonalFormData } = useInputFormsHook();
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    clearErrors,
    watch,
    reset,
  } = useForm({
    mode: "onBlur",
    resolver: yupResolver(personalFormSchema({ minAge: 18, maxAge: 65 })),
    defaultValues: {},
  });
  const [age, setAge] = useState(getPersonalFormData()?.age);
  const { tenant } = useSelector(state => state.frontendBoot?.frontendData);
  useEffect(() => {
    reset(getPersonalFormData());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reset]);
  const dispatch = useDispatch();
  const { sellerData } = useHeaderData();
  const url = tenant?.frontend_domains?.filter(
    item => item?.source === "login_url",
  )?.[0]?.base_url;
  const toaster = () => {
    toast.error(
      sellerData?.message
        ? sellerData?.message
        : "Token Expired, Login Again!!",
      {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        onClose: () => {
          window.open(url, "_self");
        },
      },
    );
  };
  const onSubmit = data => {
    if (sellerData?.status !== false) {
      dispatch(
        setData({ ...data, dob: data.dob.split(" / ").reverse().join("-") }),
      );
      setCurrent(current + 1);
      setPersonalFormData(data, age);
    } else {
      toaster();
    }
  };
  const date = watch("dob");

  return {
    onSubmit,
    handleSubmit,
    register,
    errors,
    clearErrors,
    date,
    age,
    setAge,
    setValue,
  };
};

export default usePersonalForm;
